
export default {
  steps: {
    'instruction': 'Instrucción',
    'on': 'en',
    'step': 'paso',
    'gotoStep': 'Ir al paso'
  }
}
